import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: 0,
        borderRadius: 12,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        minWidth: 520,
        '@media (max-width: 768px)': {
            minWidth: 'auto',
            width: '100%',
        }
    },
    container: {
        display: 'flex',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
        }
    },

    // Input field styles
    inputWrapper: {
        position: 'relative',
    },
    input: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '6px',
        cursor: 'pointer',
        backgroundColor: theme.palette.background.paper,
        transition: 'border-color 0.2s',
        '&:hover': {
            borderColor: theme.palette.primary.main,
        },
        '&:focus-within': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
        }
    },
    inputIcon: {
        marginRight: 8,
        color: '#3378A5',
        fontSize: '24px',
    },
    inputText: {
        fontSize: '17px',
        fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '0',
        color: theme.palette.text.primary,
    },
    inputPlaceholder: {
        fontSize: '17px',
        fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '0',
        color: theme.palette.text.secondary,
    },

    // Preset panel
    presetPanel: {
        width: 200,
        padding: 16,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        '@media (max-width: 768px)': {
            width: '100%',
            borderRight: 'none',
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
        }
    },
    presetButton: {
        justifyContent: 'flex-start',
        padding: '10px 16px',
        marginBottom: 4,
        textTransform: 'none',
        fontSize: 15,
        fontWeight: 400,
        color: theme.palette.text.primary,
        borderRadius: 6,
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        }
    },
    presetButtonActive: {
        backgroundColor: theme.palette.grey[200],
        fontWeight: 500,
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        }
    },

    // Calendar section
    calendarSection: {
        padding: 20,
        flex: 1,
        minWidth: 400,
        '@media (max-width: 768px)': {
            minWidth: 'auto',
        }
    },
    calendarHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    },
    monthYearLabel: {
        fontSize: 15,
        lineHeight: '24px',
        fontWeight: 500,
        fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        letterSpacing: '0',
        color: theme.palette.text.primary,
    },
    navigationButton: {
        padding: 8,
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        }
    },

    // Calendar grid
    weekdaysRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 4,
        marginBottom: 8,
    },
    weekdayLabel: {
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        padding: '8px 0',
    },
    daysGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
    },

    // Calendar day
    day: {
        position: 'relative',
        aspectRatio: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 15,
        fontWeight: 400,
        color: theme.palette.text.primary,
        cursor: 'pointer',
        borderRadius: 24,
        transition: 'all 0.2s',
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        },
        '&:disabled': {
            color: theme.palette.text.disabled,
            cursor: 'not-allowed',
            '&:hover': {
                backgroundColor: 'transparent',
            }
        }
    },
    dayOutsideMonth: {
        color: theme.palette.text.disabled,
    },
    dayInRange: {
        backgroundColor: '#F3F5F7',
        borderRadius: 0,
        '&:hover': {
            borderRadius: 24,
            backgroundColor: '#E8EBED',
        }
    },
    dayRangeStart: {
        backgroundColor: '#3378A5',
        color: '#FFFFFF',
        fontWeight: 600,
        borderRadius: 24,
        '&:hover': {
            backgroundColor: '#2A6388',
        }
    },
    dayRangeEnd: {
        backgroundColor: '#3378A5',
        color: '#FFFFFF',
        fontWeight: 600,
        borderRadius: 24,
        '&:hover': {
            backgroundColor: '#2A6388',
        }
    },
    dayToday: {
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 4,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 4,
            height: 4,
            borderRadius: '50%',
            backgroundColor: '#3378A5',
        }
    }
}));
